import { gql } from '@yi/core';

import { useSignupUrlBySubscriptionOffer } from './useSignupUrl';

export function useAnnualSignUpUrl() {
  const urlDetails = useSignupUrlBySubscriptionOffer(gql.typesClient.SubscriptionOffer.ANNUAL);
  return urlDetails;
}
